import gql from 'graphql-tag';

export const CREATE_SERVICE_PRICE_CHANGE_SCHEDULE = gql`
  mutation createServicePriceChangeSchedule($input: CreateServicePriceChangeScheduleInput!) {
    createServicePriceChangeSchedule(input: $input) {
      servicePriceChangeSchedule {
        id
        scheduledAt
        servicePriceChanges {
          id
          newPrice
          originalPrice
          service {
            id
          }
        }
      }
    }
  }
`;

export const UPDATE_SERVICE_PRICE_CHANGE_SCHEDULE = gql`
  mutation updateServicePriceChangeSchedule($input: UpdateServicePriceChangeScheduleInput!) {
    updateServicePriceChangeSchedule(input: $input) {
      servicePriceChangeSchedule {
        id
        scheduledAt
        servicePriceChanges {
          id
          newPrice
          originalPrice
          service {
            id
          }
        }
      }
    }
  }
`;
